import React from "react";

const PageTwo = () => {
    return (
        <div>
            PageTwo页面
        </div>
    )
}

export default PageTwo